import { api } from '@/scripts/api';

export const SocialMediaPostService = {

    getAll(config = {}, clientId) {
        return new Promise((resolve, reject) => {
            const service  = `/ms/socialmedia/v1/socialpost/${clientId}`;
            const endpoint = api.applyNodeDataParams(service, config);

            api.get(endpoint)
                .then(resolve)
                .catch(reject);

        });
    },

    get(id, clientId){
        return new Promise((resolve, reject) => {
            const service = `/ms/socialmedia/v1/socialpost/${id}/${clientId}`;

            api.get(service)
                .then(resolve)
                .catch(reject);
        })
    },

    /**
     * Returns the original post
     *
     * @param   {int}     postId   Post Id
     * @param   {int}     clientId Client Id
     * @return  {promise}
     */
    getPostPreview(postId, clientId) {
        return new Promise((resolve, reject) => {
            const service = `/ms/socialmedia/v1/socialpost/${ postId }/preview/${ clientId }`

            api.get(service)
                .then(resolve)
                .catch(reject)
        })
    },

    post(clientId, payload){
        return new Promise((resolve, reject) => {
            const service = `/ms/socialmedia/v1/socialpost/${clientId}`;

            api.post(service, payload)
                .then(resolve)
                .catch(reject);
        })
    },

    postPreviewUrl(payload) {
        return new Promise((resolve, reject) => {
            const service = '/ms/socialmedia/v1/socialpost/get-link-preview';

            api.post(service, payload)
            .then(resolve)
            .catch(reject);
        });
    },

    postBulk(clientId, payload) {
        return new Promise((resolve, reject) => {
            const service = `/ms/socialmedia/v1/socialpost/bulk-duplicate-media/${clientId}`;

            api.post(service, payload)
            .then(resolve)
            .catch(reject);
        });
    },

    putImage(url, fileToUpload, config) {
        return new Promise((resolve, reject) => {
            api.putInstance(url, fileToUpload, config)
            .then(resolve)
            .catch(reject);
        });
    },

    patch(id, clientId, payload) {
        return new Promise((resolve, reject) => {
            const service = `/ms/socialmedia/v1/socialpost/${id}/${clientId}`;
            
            api.msPatch(service, payload)
                .then(resolve)
                .catch(reject);
        });

    },

    delete(id, clientId){
        return new Promise((resolve, reject) => {
            const service = `/ms/socialmedia/v1/socialpost/${id}/${clientId}`;

            api.delete(service)
                .then(resolve)
                .catch(reject);
        })
    },

    publish(id, clientId) {
        return new Promise((resolve, reject) => {
            const service = `/ms/socialmedia/v1/socialpost/${id}/publish/${clientId}`;
            
            api.put(service)
                .then(resolve)
                .catch(reject);
        });

    },

    putSchedule(postId, clientId, payload) {
        return new Promise((resolve, reject) => {
            const service = `/ms/socialmedia/v1/socialpost/${postId}/schedule/${clientId}`;

            api.put(service, payload)
                .then(resolve)
                .catch(reject);
        });
    },

    putUnschedule(postId, clientId) {
        return new Promise((resolve, reject) => {
            const service = `/ms/socialmedia/v1/socialpost/${postId}/unschedule/${clientId}`;

            api.put(service)
                .then(resolve)
                .catch(reject);
        });
    },
    
    duplicate(clientId, payload){
        return new Promise((resolve, reject) => {
            const service = `/ms/socialmedia/v1/socialpost/duplicate/${clientId}`;

            api.post(service, payload)
                .then(resolve)
                .catch(reject);
        })
    },
}
